<template lang="pug">
#document_download
  custom-header(
    :title="fileDownloadPage.area01_Title",
    :subTitle="fileDownloadPage.area01_SubTitle",
    :image="fileDownloadPage.area01_Image",
    :buttonName="fileDownloadPage.area01_ButtonName",
    :buttonURL="fileDownloadPage.area01_ButtonURL"
  )
  .container-fluid.i_pb_12
    section.container
      h2.i_h2_title.text-center.i_pt_10 {{ fileDownloadPage.area02_Title }}
      nav.top_tab.d-flex.flex-wrap.flex-md-nowrap.justify-content-start.justify-content-md-center.i_mt_10.i_ml_per_sm_1
        nav-tab(
          v-for="(productCategory, index) in productCategory.ProductCategoryList",
          :key="index",
          :title="productCategory.ProductCategoryName",
          :selected="selectedLink == index",
          @click.native="changeTab(index)"
        )
      .sub_tab.d-flex.justify-content-center.i_mt_6
        indicator-tab(
          v-for="(product, index) in productDetail.ProductList",
          :key="index",
          :tabContent="product",
          :selected="selectedSubLink == index",
          @click.native="changeSubTab(index)"
        )

    section.container.document_container
      .row
        .col-12.col-md-6.left
          document.fade.i_mt_10.i_mt_sm_2(
            :document="document",
            v-for="(document, index) in leftFileList",
            :key="index"
          )
        .col-12.col-md-6.right
          document.fade.i_mt_10.i_mt_sm_2(
            :document="document",
            v-for="(document, index) in rightFileList",
            :key="index"
          )

  dedicated-line
</template>

<script>
import CustomHeader from "@/components/customer_service/Header";
import { getFileDownloadPage } from "@/json/customer_service";
import { getFileDownload } from "@/json/customer_service";
import { getProductCategory } from "@/json/product";
import NavTab from "@/components/customer_service/NavTab";
import IndicatorTab from "@/components/common/IndicatorTab";
import DedicatedLine from "@/components/customer_service/DedicatedLine";
import Document from "@/components/customer_service/Document";

export default {
  name: "CustomerServiceDocumentDownload",
  metaInfo() {
    return {
      title: this.fileDownloadPage.SEO_Title,
      meta: [{ name: "description", content: this.fileDownloadPage.SEO_Description }],
    };
  },
  components: {
    "custom-header": CustomHeader,
    "nav-tab": NavTab,
    "indicator-tab": IndicatorTab,
    document: Document,
    "dedicated-line": DedicatedLine,
  },
  data() {
    return {
      fileDownloadPage: {},
      productCategory: {},
      productDetail: {},
      fileDownload: {},
      leftFileList: [],
      rightFileList: [],
      selectedLink: 0,
      selectedSubLink: 0,
      defaultTab: -1,
      defaultSubTab: -1,
    };
  },
  created() {
    this.getFileDownloadPage();
    this.getProductCategory();
  },
  methods: {
    changeTab(index) {
      this.selectedLink = index;
      this.productDetail = this.productCategory.ProductCategoryList[index];

      if (this.defaultSubTab != -1) {
        this.changeSubTab(this.defaultSubTab);
        this.defaultSubTab = -1;
      } else {
        this.changeSubTab(0);
      }
    },
    changeSubTab(index) {
      this.selectedSubLink = index;
      this.leftFileList = [];
      this.rightFileList = [];
      let tempId = this.productDetail.ProductList[index].ProductID;
      for (let index in this.fileDownload.FileCategoryList) {
        let fileCategory = this.fileDownload.FileCategoryList[index];
        if (tempId == fileCategory.ProductID) {
          if ("1" == fileCategory.FileCategoryArea) {
            this.leftFileList.push(fileCategory);
          } else if ("2" == fileCategory.FileCategoryArea) {
            this.rightFileList.push(fileCategory);
          }
        }
      }
    },
    getFileDownloadPage() {
      getFileDownloadPage().then((response) => {
        this.fileDownloadPage = response.data;
      });
    },
    getFileDownload() {
      getFileDownload().then((response) => {
        this.fileDownload = response.data;
        if (
          this.productCategory.ProductCategoryList &&
          this.productCategory.ProductCategoryList.length > 0
        ) {
          if (this.$route.params.type && this.$route.params.type != "") {
            for (let index in this.productCategory.ProductCategoryList) {
              let tab = this.productCategory.ProductCategoryList[index];
              for (let y in tab.ProductList) {
                let subTab = tab.ProductList[y];
                if (this.$route.params.type == subTab.ProductJson) {
                  this.defaultTab = index;
                  this.defaultSubTab = y;
                }
              }
            }

            if (this.defaultTab != -1) {
              this.changeTab(this.defaultTab);
              this.defaultTab = -1;
            } else {
              this.changeTab(0);
            }
          } else {
            this.changeTab(0);
          }
        }
      });
    },
    getProductCategory() {
      getProductCategory().then((response) => {
        this.productCategory = response.data;
        this.getFileDownload();
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/style/customer_service/document_download";
</style>
